<template>
  <div class="viq-sources">
    <div class="viq-sources__header">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
      <span>{{ sources.length }} {{ sources.length === 1 ? 'source' : 'sources' }}</span>
    </div>
    <div class="viq-sources__scroll">
      <ViqSourceCard
        v-for="(source, i) in sources"
        :key="i"
        :source="source"
        :index="i + 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqSourceCards",
  components: {
    ViqSourceCard: () => import("./ViqSourceCard"),
  },
  props: {
    sources: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-sources {
  margin-top: $viq-space-md;

  &__header {
    display: flex;
    align-items: center;
    gap: $viq-space-sm;
    font-size: $viq-font-sm;
    font-weight: 600;
    color: $viq-text-secondary;
    margin-bottom: $viq-space-sm;
  }

  &__scroll {
    display: flex;
    gap: $viq-space-sm;
    overflow-x: auto;
    padding-bottom: $viq-space-sm;

    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 2px;
    }
  }
}
</style>
